const RISK_RULES = [
  { level: 5, label: '最高风险', fields: { sxr: '失信被执行人', xsss: '刑事诉讼（刑事记录）' } },
  { level: 4, label: '高风险', fields: { xg: '限制高消费', zxjl: '被执行记录' } },
  { level: 3, label: '中风险', fields: { sa: '涉案（涉诉记录）' } },
  { level: 2, label: '低风险', fields: { msjf: '民商事纠纷', ldjf: '劳动纠纷' } },
]

const ALL_RISK_FIELDS = RISK_RULES.flatMap((rule) => Object.keys(rule.fields))

function normalizeFlag(value) {
  if (value === true || value === 1 || value === '1' || value === 'true') return true
  if (value === false || value === 0 || value === '0' || value === 'false') return false
  return null
}

function normalizeRiskRecord(value) {
  let parsed = value
  if (typeof parsed === 'string') {
    try {
      parsed = JSON.parse(parsed)
    } catch (error) {
      return null
    }
  }
  if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) return null

  const record = Object.keys(parsed).reduce((result, key) => {
    result[String(key).toLowerCase()] = parsed[key]
    return result
  }, {})
  // 需求文档有一处将小写 l 写成了大写 I，兼容已对接的异常字段。
  if (!Object.prototype.hasOwnProperty.call(record, 'ldjf') && Object.prototype.hasOwnProperty.call(record, 'idjf')) {
    record.ldjf = record.idjf
  }
  return record
}

/**
 * 解析支付宝司机社会风险字段。同时命中多项时，严格取最高风险等级。
 */
export function parseSocialRiskDesc(value) {
  const record = normalizeRiskRecord(value)
  if (!record) return null

  const normalizedFields = ALL_RISK_FIELDS.reduce((result, field) => {
    if (!Object.prototype.hasOwnProperty.call(record, field)) return result
    result[field] = normalizeFlag(record[field])
    return result
  }, {})
  const hasCompleteResult = ALL_RISK_FIELDS.every((field) => normalizedFields[field] !== undefined && normalizedFields[field] !== null)
  if (!hasCompleteResult) return null

  const hitLabels = RISK_RULES.flatMap((rule) => Object.entries(rule.fields)
    .filter(([field]) => normalizedFields[field] === true)
    .map(([, label]) => label))
  const matchedRule = RISK_RULES.find((rule) => Object.keys(rule.fields).some((field) => normalizedFields[field] === true))

  if (!matchedRule) {
    return { level: 0, label: '未查询到风险', hitLabels: [] }
  }
  return {
    level: matchedRule.level,
    label: matchedRule.label,
    hitLabels,
  }
}

export function getLegacySocialRiskResult(value) {
  const risk = normalizeFlag(value)
  if (risk === null) return null
  return risk
    ? { level: -1, label: '存在风险', hitLabels: [] }
    : { level: 0, label: '未查询到风险', hitLabels: [] }
}
